
import { Component, Prop, Vue } from 'vue-property-decorator'
import {
  getGelegramGroup,
  editGelegramGroup,
  delGelegramGroup,
  getGroupCategoryList
} from '@/api/system'
import { getMerchant } from '@/api/merchant/merchant'
import { delObjEmptyKey } from '@/utils'
import { AppModule } from '@/store/modules/app'
import { Form as ElForm } from 'element-ui'
import { getType } from '@/utils/cookies'

@Component({
  name: 'Picsloader'
})
export default class extends Vue {
  @Prop() private attachUrl!: any
  @Prop() private attachName!: any

  private queryForm: any = {
    name: '',
    telegram_id: '',
    merchant_no: '',
    category_id: ''
  }
  private editForm: any = {
    merchant_no: '',
    category_id: '',
    currency: '',
    bot_type: '',
    forward_chat_id: '',
    forward_extra_text: '',
    bot_cert_style: '',
    merchant_no_list: []
  }
  private currencyTypes = AppModule.enterprise.available_currency

  get language() {
    return AppModule.language
  }
  private listLoading: any = false
  private list: any = []
  private total = 0
  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 群列表
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      let data = {}
      if (this.attachName === '8') {
        data = {
          ...this.queryForm,
          group_type: 'fp',
          page_size: this.pagesize,
          page: this.currentPage
        }
      } else {
        data = {
          ...this.queryForm,
          page_size: this.pagesize,
          page: this.currentPage
        }
      }

      delObjEmptyKey(data)
      await getGelegramGroup(data).then((res: any) => {
        this.list = res.results
        this.list.map((item: any, index: number) => {
          if (
            item.photo_switch === null ||
            item.photo_switch === false ||
            item.photo_switch === 0
          ) {
            item.photo_switch = false
          } else if (item.photo_switch === true || item.photo_switch === 1) {
            item.photo_switch = true
          }
          if (this.sysType === 'ant') {
            if (item.ant_ocr_switch === null || item.ant_ocr_switch === '0') {
              item.ant_ocr_switch = '0'
            } else {
              item.ant_ocr_switch = '1'
            }
          }
          // this.$set(this.list, index, item)
        })
        this.total = res.count
        this.listLoading = false
      })
    } catch (error) {
      this.listLoading = false
    }
  }

  // 群分类
  private groupTypeList: any = []
  private async onloadGroupType() {
    try {
      const data: any = {
        page_size: 500,
        page: 1
      }
      delObjEmptyKey(data)
      await getGroupCategoryList(data).then((res: any) => {
        this.groupTypeList = res.results
      })
    } catch (error) {
      console.log()
    }
  }

  // 获取Telegram商户群组
  private chatIdsList: any = []
  private async getTelegroupList() {
    try {
      let params: any = {
        page: 1,
        page_size: 500
      }
      await getGroupCategoryList(params).then((res: any) => {
        this.chatIdsList = res.results
        // this.newList = res
      })
    } catch (e) {
      console.log()
    }
  }

  // 商户列表
  private options: any = []
  private async getMerchantList() {
    try {
      const data: any = {
        page_size: 200,
        page: 1
      }
      await getMerchant(data).then((res: any) => {
        this.options = res.results
      })
    } catch (e) {
      console.log()
    }
  }

  // 远程查询商户
  private async getMerchantListByName(query: string) {
    try {
      const data: any = {
        name: query
      }
      await getMerchant(data).then((res: any) => {
        this.options = res.results
      })
    } catch (e) {
      console.log()
    }
  }

  // 关闭弹框
  private close() {
    this.editForm = {
      merchant_no: '',
      category_id: '',
      currency: '',
      bot_type: '',
      forward_chat_id: '',
      forward_extra_text: '',
      bot_cert_style: '',
      merchant_no_list: []
    }
    this.sendMesVisible = false
    this.currentPage = 1
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
    })
  }

  // 保存
  private async save() {
    this.listLoading = true

    const data: any = {
      id: this.editData.id,
      merchant_no: this.editForm.merchant_no,
      category_id: this.editForm.category_id,
      currency: this.editForm.currency,
      bot_type: this.editForm.bot_type,
      forward_chat_id: this.editForm.forward_chat_id,
      forward_extra_text: this.editForm.forward_extra_text,
      bot_cert_style: this.editForm.bot_cert_style,
      merchant_no_list: this.editForm.merchant_no_list
    }
    delObjEmptyKey(data)
    await editGelegramGroup(data).then(() => {
      if (this.language === 'en') {
        this.$message({
          message: 'Edit successful!',
          type: 'success'
        })
      }
      if (this.language === 'zh_cn') {
        this.$message({
          message: '编辑成功！',
          type: 'success'
        })
      }
      if (this.language === 'zh_tw') {
        this.$message({
          message: '編輯成功！',
          type: 'success'
        })
      }
      this.close()
      this.listLoading = false
    })
  }

  // 启用关闭
  private async stop(row, flag) {
    try {
      this.listLoading = true
      const data: any = {
        id: row.id,
        is_active: flag
      }
      delObjEmptyKey(data)
      await editGelegramGroup(data).then((res: any) => {
        if (this.language === 'en') {
          this.$message({
            message: 'Update Successful!',
            type: 'success'
          })
        }
        if (this.language === 'zh_cn') {
          this.$message({
            message: '更新成功！',
            type: 'success'
          })
        }
        if (this.language === 'zh_tw') {
          this.$message({
            message: '更新成功！',
            type: 'success'
          })
        }
        this.hadleGetFilesListApi()
        this.listLoading = false
      })
    } catch (error) {
      this.listLoading = false
    }
  }

  // 绑定商户
  private sendMesVisible: any = false
  private editData: any = {}
  private edit(row) {
    this.editForm.merchant_no = row.group_merchant
    this.editForm.currency = row.currency
    this.editForm.forward_chat_id = row.forward_chat_id
    this.editForm.forward_extra_text = row.forward_extra_text
    this.editForm.bot_cert_style = row.bot_cert_style
    this.editForm.bot_type = row.bot_type
    if (row.merchant_no_list) {
      this.editForm.merchant_no_list = row.merchant_no_list
    }
    if (row.category) {
      let arr = this.chatIdsList.filter(item => {
        return item.name === row.category
      })
      this.editForm.category_id = arr[0].id
    } else {
      this.editForm.category_id = ''
    }
    this.sendMesVisible = true
    this.editData = row
  }

  // 删除列表
  private del(row) {
    if (this.language === 'en') {
      this.$confirm(
        'Are you sure you want to delete the telegram group and exit the group?',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
          callback: action => {
            if (action === 'confirm') {
              this.delGroup(row.id)
            }
          }
        }
      )
    }
    if (this.language === 'zh_cn') {
      this.$confirm('您确定要删除telegram群组并且退出群组?', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            this.delGroup(row.id)
          }
        }
      })
    }
    if (this.language === 'zh_tw') {
      this.$confirm('您確定要刪除telegram群組並且退出群組?', {
        confirmButtonText: '刪除',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            this.delGroup(row.id)
          }
        }
      })
    }
  }
  // 删除
  private async delGroup(id) {
    try {
      this.listLoading = true
      const params: any = {
        id: id
      }
      await delGelegramGroup(params).then((res: any) => {
        if (this.language === 'en') {
          this.$message({
            message: 'Delete successful!',
            type: 'success'
          })
        }
        if (this.language === 'zh_cn') {
          this.$message({
            message: '删除成功！',
            type: 'success'
          })
        }
        if (this.language === 'zh_tw') {
          this.$message({
            message: '删除成功！',
            type: 'success'
          })
        }
        this.hadleGetFilesListApi()
        this.listLoading = false
      })
    } catch (error) {
      this.listLoading = false
    }
  }

  private reset() {
    this.queryForm = {
      name: '',
      telegram_id: '',
      merchant_no: '',
      category_id: '',
      forward_chat_id: '',
      forward_extra_text: ''
    }
    this.currentPage = 1
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
    })
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private async geogleStatusSwitch(val, str) {
    try {
      this.listLoading = true
      let data: any = {}
      if (str === 'photo') {
        data = {
          id: val.id,
          photo_switch: val.photo_switch
        }
      } else {
        data = {
          id: val.id,
          ant_ocr_switch: val.ant_ocr_switch
        }
      }
      await editGelegramGroup(data).then((res: any) => {
        if (this.language === 'en') {
          this.$message({
            message: 'Edit successful!',
            type: 'success'
          })
        }
        if (this.language === 'zh_cn') {
          this.$message({
            message: '编辑成功！',
            type: 'success'
          })
        }
        if (this.language === 'zh_tw') {
          this.$message({
            message: '編輯成功！',
            type: 'success'
          })
        }
        this.hadleGetFilesListApi()
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private sysType: any = ''
  mounted() {
    this.sysType = getType()
    this.hadleGetFilesListApi()
    this.getMerchantList()
    this.getTelegroupList()
    this.onloadGroupType()
  }

  created() {}
}
